import { BooleanParam, StringParam, withDefault } from 'use-query-params';

import {
  ChallengeExternalSystemParam,
  ChallengeStatusesParam,
} from '@/utils/query/params';

export const queryParams = {
  challengeId: StringParam,
  desc: withDefault(BooleanParam, true),
  challengeUUID: StringParam,
  name: StringParam,
  status: ChallengeStatusesParam,
  challengeSystem: ChallengeExternalSystemParam,
  before: StringParam,
  after: StringParam,
};
